// export const isCypress = typeof window !== 'undefined' && !!(window as any).Cypress;

const isRunningInCypress = (win: typeof window): win is typeof window & { Cypress: object } => {
    return 'Cypress' in win;
};

export const isInCypressEnvironment = typeof window !== 'undefined' && isRunningInCypress(window);
